import React from "react";
import styles from "./LargeBoxButtons.module.scss";

function LargeBoxButtons(props) {
    return (
        <div className={`${styles.input4} ${styles.largeBoxes}`}>
          <label htmlFor={props.keyName} className={styles.boxLabel}>{props.label || props.title}</label>
          <div className={styles.largeBoxList}>
            {Object.entries(props.boxes).map((e, i) => {
              return (
                <div key={i} className={`${styles.clOption}`}>
                  <input
                    className={styles.checkListInput}
                    id={"checkbox" + i}
                    type="radio"
                    name={props.keyName}
                    checked={e[1]}
                    onChange={() =>
                      props.onChange(props.keyName, e[1], "checklist", e[0])
                    }
                    disabled={props.disabled}
                  />
                  <label className={`${props.xs ? styles.xs : props.md ? styles.md : props.sm ? styles.sm : styles.lg}`} htmlFor={"checkbox" + i}>
                    {props.labels[i].title}
                    <div className={styles.description} style={{display: (props.labels[i].description ? "flex" : "none")}}>{props.labels[i].description}</div>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
    )
};

export default LargeBoxButtons;